/*jshint esversion: 6 */
import Swiper from 'swiper';
import { Pagination, Navigation } from 'swiper/modules';

const NewsGrid = (function($) {

  const _s = {
    container: '.wp-block-indp-news-grid'
  };

  const _init = function() {
    if ($(_s.container).length === 0) {
      return;
    }

    _handleSwiper();
  };

  // ===================
  // Initialize Swiper
  const _handleSwiper = function() {
    const grids = document.querySelectorAll(_s.container);
    
    grids.forEach((grid) => {
      const swiperEl = grid.querySelector('.swiper');
      if (!swiperEl) {
        return;
      }
      
      const prevButton = grid.querySelector('.wp-block-indp-news-grid__nav-prev');
      const nextButton = grid.querySelector('.wp-block-indp-news-grid__nav-next');
      
      new Swiper(swiperEl, {
        modules: [Pagination, Navigation],
        slidesPerView: 1.2,
        spaceBetween: 20,
        centeredSlides: false,
        loop: false,
        navigation: {
          prevEl: prevButton,
          nextEl: nextButton,
        },
        pagination: {
          el: '.wp-block-indp-news-grid__pagination',
          type: 'progressbar',
        },
        breakpoints: {
          480: {
            slidesPerView: 1.5,
            spaceBetween: 20,
          },
          640: {
            slidesPerView: 2.2,
            spaceBetween: 25,
          },
          782: {
            slidesPerView: 3,
            spaceBetween: 25,
          },
          1100: {
            slidesPerView: 4,
            spaceBetween: 25,
          }
        }
      });
    });
  };

  return {
    container: _s.container,
    init: _init
  };

})(jQuery);

export default NewsGrid;
